module.exports = __webpack_public_path__ + "static/img/cloud-hosting-bg.c5ada37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-hosting-bg.png
// module id = oGI7
// module chunks = 0